/**
 * Dados iniciais usados na pré-renderização (HTML gerado no build).
 *
 * No navegador não há provider: as páginas buscam os dados na API. No build,
 * o provider entrega os planos para que o HTML estático já traga preços e
 * recursos (buscadores e robôs de IA não executam JavaScript).
 */

import { createContext } from 'react';
import type { SubscriptionPlan } from '@services/platformService';

export interface PrerenderData {
  plans: SubscriptionPlan[];
}

export const PrerenderDataContext = createContext<PrerenderData | null>(null);
